import type { AsOf, Head, Tier } from "@kinetiq/wire";
import { createStore } from "./store.ts";

// THE POSITION EVERY PAYLOAD IS CURRENT AS OF.
//
// The declaration moved to `@kinetiq/wire` (todo.md B1, landed) exactly as the note that stood here planned.
// It is a RE-EXPORT and not a second declaration: `packages/wire/tests/conformance.test.ts` pins that symbol
// to `StoreFacade`'s own `AsOf`, so a field renamed in the store is a compile error in this app rather than a
// screen that quietly renders "—". The stitch's whole correctness argument is built on these four field
// names, which is why they may not have two homes.
export type { AsOf, Head, Tier };

// `null` until the first `status/head` frame arrives. NULL IS NOT ZERO: a zero slot would render as "the chain
// is at genesis" and a zero second as "56 years behind", and both look like data. Every reader must branch.
export const asOfStore = createStore<AsOf | null>(null);

// THE HEAD PAYLOAD, BESIDE THE POSITION — and it is a SECOND store rather than four more fields on the first
// because they answer different questions and change on different cadences.
//
// `AsOf` says WHERE we are. `Head` says WHETHER THAT POSITION IS HEALTHY, and only the server can:
//
//   • `stalledSec` — seconds since `second` last advanced. THE BROWSER CANNOT COMPUTE THIS. The only clock it
//     holds that is comparable to `asOf.second` is chain time, which IS `asOf.second`; subtracting a wall
//     clock instead reports the block-time lag (3–12 s, healthy) as staleness. That mistake is why the badge
//     shipped with no age at all rather than a wrong one.
//   • `behind` — (an INDEPENDENT RPC tip) − slot. NEVER derived from our own cursor, which is circular and
//     has produced wrong conclusions in this repo. `null` when no independent tip is configured, and `null`
//     must render as "unknown", never as 0.
//   • `shedLevel` — the server is dropping work to keep up. A quiet screen under load is otherwise
//     indistinguishable from a quiet market.
//
// ONE WRITER, `stream/status.ts`, exactly as with `asOfStore`.
export const headStore = createStore<Head | null>(null);
